import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Input, Label, FormGroup, Button } from "reactstrap";
import { getCategories } from "../../redux/actions/indexActions";
const UpdateSubCategory = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth },
    indexReducer: { categoriesList },
  } = useSelector((state) => state);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    name_english: "",
    name_hindi: "",
    category_id: "",
    title_english: "",
    title_hindi: "",
    description_english: "",
    short_description_english: "",
    description_hindi: "",
    short_description_hindi: "",
    status: 1,
    landscape_image: "",
    portrait_image: "",
    featured: "",
  });
  const navigate = useNavigate();
  const inputHandler = (e) => {
    const { name, value } = e.target;
    const file = e.target.files ? e.target.files[0] : null;

    if (name === "portrait_image" || name === "landscape_image") {
      const reader = new FileReader();
      reader.onload = (event) => {
        const image = new Image();
        image.src = event.target.result;

        image.onload = () => {
          const width = image.width;
          const height = image.height;

          if (name === "portrait_image" && (width !== 1280 || height !== 1920)) {
            setErrors({ ...errors, portrait_image: "Image dimensions must be 1280x1920 pixels" });
          } else if (name === "landscape_image" && (width !== 1080 || height !== 720)) {
            setErrors({ ...errors, landscape_image: "Image dimensions must be 1080x720 pixels" });
          } else {
            setErrors({ ...errors, [name]: "" });
            setFormData({ ...formData, [name]: file });
          }
        };
      };

      reader.readAsDataURL(file);
    }
    if (name === "status") {
      setFormData({ ...formData, [name]: e.target.checked ? 1 : 0 });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  useEffect(() => {
    dispatch(getCategories(auth.token));
  }, [auth]);

  useEffect(() => {
    if (id) {
      axios(`/api/admin/v1/sub/category/${id}`, {
        headers: {
          Authorization: `Bearer ${auth?.token}`,
        },
      })
        .then((res) => {
          setFormData((prev) => {
            return {
              ...prev,
              category_id: res.data?.subCategory?.category_id,
              name_english: res.data?.subCategory?.name_english,
              name_hindi: res.data?.subCategory?.name_hindi,
              title_english: res.data?.subCategory?.title_english,
              title_hindi: res.data?.subCategory?.title_hindi,
              description_english: res.data?.subCategory?.description_english,
              short_description_english:
                res.data?.subCategory?.short_description_english,
              description_hindi: res.data?.subCategory?.description_hindi,
              short_description_hindi:
                res.data?.subCategory?.short_description_hindi,
              status: res.data?.subCategory?.status,
              featured: res.data?.subCategory?.featured ?? 0,
            };
          });
        })
        .catch((err) => console.log(err));
    }
  }, [id, auth, categoriesList]);

  const handleSubmit = () => {
    const form = new FormData();
    form.append('category_id', formData.category_id)
    form.append('title_english', formData.title_english)
    form.append('title_hindi', formData.title_hindi)
    form.append('name_english', formData.name_english)
    form.append('name_hindi', formData.name_hindi)
    form.append('short_description_english', formData.short_description_english)
    form.append('short_description_hindi', formData.short_description_hindi)
    form.append('description_english', formData.description_english)
    form.append('description_hindi', formData.description_hindi)
    form.append('landscape_image', formData.landscape_image)
    form.append('portrait_image', formData.portrait_image)
    form.append("featured", formData.featured)
    form.append("status", formData.status)
    axios
      .put(`/api/admin/v1/sub/category/${id}`, form, {
        headers: {
          Authorization: `Bearer ${auth?.token}`,
        },
      })
      .then((res) => {
        toast.success(res.data?.message);
        navigate(-1);
      })
      .catch((err) => {
        toast.error(err.response.data);
        setErrors(err.response.data);
      });
  };
  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <h5 className="text-white">Edit Sub Category</h5>
        </div>
      </div>
      <div className="bg-white px-3 py-4 rounded-2  my-4">
        <div className="row">
          {/* <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Category Type</Label>
              <Multiselect className="text-black"
                options={categoriesList}
                displayValue="name"
                selectedValues={formData.consultanttype}
                onSelect={(val) =>
                  setFormData({ ...formData, consultanttype: [...val] })
                }
              />
            </FormGroup>
          </div> */}
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Category<span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.category_id}
                type="select"
                name="category_id"
                onChange={inputHandler}
              >
                <option value="">Select Category</option>
                {categoriesList.map((item) => {
                  return (
                    <option key={item.id} value={item.id}>
                      {item?.name}
                    </option>
                  );
                })}
              </Input>
              <span className="d-block text-danger">{errors?.category_id}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Title English <span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.title_english}
                name="title_english"
                onChange={inputHandler}
              />
              <span className="d-block text-danger">{errors?.title_english}</span>
            </FormGroup>
          </div>

          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Title Hindi</Label>
              <Input
                value={formData?.title_hindi}
                name="title_hindi"
                onChange={inputHandler}
              />
              <span className="d-block text-danger">{errors?.title_hindi}</span>
            </FormGroup>
          </div>

          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>English Name <span className="text-danger fs-4">*</span></Label>
              <Input
                value={formData?.name_english}
                name="name_english"
                onChange={inputHandler}
              />
              <span className="d-block text-danger">{errors?.name_english}</span>
            </FormGroup>
          </div>

          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Hindi Name</Label>
              <Input
                value={formData?.name_hindi}
                name="name_hindi"
                onChange={inputHandler}
              />
              <span className="d-block text-danger">{errors?.name_hindi}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Featured</Label>
              <Input
                value={formData?.featured}
                name="featured"
                onChange={inputHandler}
              />
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Landscape Image</Label>
              <Input
                type="file"
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    landscape_image: e.target.files[0],
                  }))
                }
              />
            </FormGroup>
          </div>

          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Portrait Image</Label>
              <Input
                type="file"
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    portrait_image: e.target.files[0],
                  }))
                }
              />
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Short Hindi Description</Label>
              <Input
                name="short_description_hindi"
                value={formData?.short_description_hindi}
                type="textarea"
                onChange={inputHandler}
              />
              <span className="d-block text-danger">{errors?.short_description_hindi}</span>
            </FormGroup>
          </div>

          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Short English Description <span className="text-danger fs-4">*</span></Label>
              <Input
                name="short_description_english"
                value={formData?.short_description_english}
                type="textarea"
                onChange={inputHandler}
              />
              <span className="d-block text-danger">{errors?.short_description_english}</span>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>English Full Description</Label>
              <Input
                value={formData?.description_english}
                name="description_english"
                type="textarea"
                onChange={inputHandler}
              />
            </FormGroup>
          </div>

          <div className="col-md-4 offset-md-1">
            <FormGroup>
              <Label>Hindi Full Description</Label>
              <Input
                value={formData?.description_hindi}
                name="description_hindi"
                type="textarea"
                onChange={inputHandler}
              />
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-1">
            <FormGroup switch>
              <Input
                type="switch"
                checked={formData?.status}
                onChange={inputHandler}
                name="status"
              />
              <Label check>Status</Label>
            </FormGroup>
          </div>
          <div className="col-md-4 offset-md-4">
            <Button color="primary" onClick={handleSubmit}>
              Submit
            </Button>
            <Button className="ms-3" onClick={() => navigate(-1)}>
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateSubCategory;
